import { createXRStore } from "@react-three/xr";

// Enable the controller/hand teleport pointer so users can teleport in VR.
export const xrStore = createXRStore({
  controller: { teleportPointer: true },
  hand: { teleportPointer: true },
});
